import { useContext, useState, useEffect, createContext, Children } from 'react';
import { account } from "./appwriteConfig";
import { useNavigate } from "react-router-dom";
import { ID } from 'appwrite';  // Add this import




const AuthContext = createContext();


export const AuthProvider = ({ children }) => {

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


    //--------------------------------------------------------------------------------

    useEffect(() => {

        checkUserStatus();

    }, []);


    //--------------------------------------------------------------------------------

    const loginUser = async (userInfo) => {



        setLoading(true);


        try {

            let response = await account.createEmailPasswordSession(
                userInfo.email,
                userInfo.password
            );

            //session is logged in response,now to get the users details
            let accountDetails = await account.get()

            setUser(accountDetails);



            console.log('Session: ', response);
            console.log('Acc Details: ', accountDetails);

            navigate('/Home');


        } catch (e) {
            setUser(null);
            console.log(e);
        }

        setLoading(false);
    }


    //--------------------------------------------------------------------------------
    const logoutUser = async () => {

        console.log('Logging out...');

        setLoading(true);

        try {
            await account.deleteSession('current');
            setUser(null)
            setLoading(true);
            navigate('/');


        } catch (error) {
            console.log(error)

        }finally {
            setLoading(false);
            
        }


    }



    //--------------------------------------------------------------------------------

    const registerUser = async (userInfo) => {

        setLoading(true);

        try {
            let response = await account.create(ID.unique(), userInfo.email, userInfo.password, userInfo.name);
            console.log("Account creation response:", response);






        } catch (error) {
            console.error("Error during user registration process:", error);
            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
                console.error("Response headers:", error.response.headers);
            }

        } finally {
            setLoading(false);
            loginUser(userInfo);
        }


    };




    //--------------------------------------------------------------------------------
    const checkUserStatus = async () => {

        try {
            let accountDetails = await account.get();

            setUser(accountDetails)
            console.log('Session: ', accountDetails);
            navigate('/Home');

        } catch (error) {

            console.log(error);
            setUser(null)
            navigate('/')

        }
        setLoading(false)
    }




    //--------------------------------------------------------------------------------
    const contextData = {
        user,
        loginUser,
        logoutUser,
        registerUser,
    }




    return (

        <AuthContext.Provider value={contextData}>

            {loading ? (
                <div className="centerit">
                    <p>Checking Authentication..</p>
                </div>) : children}

        </AuthContext.Provider>)

}








export const useAuth = () => {

    return useContext(AuthContext)
}

export default AuthContext

